// Libs
import { useState } from "react";
import { Field, Form, Formik } from "formik";
// UI-Components
import {
  OutletHeading,
  OutletSubHeading,
} from "../../UI-Components/OutletWrapper";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogIcon,
  DialogTitle,
} from "../../UI-Components/Dialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../UI-Components/Select";
import SuccessIcon from "../../UI-Components/SuccessIcon";
import { Label } from "../../UI-Components/Label";
import { Input } from "../../UI-Components/Input";
import { Button } from "../../UI-Components/Button";
import DocumentUpload from "../DocumentUpload";
// Types
import { UpdateClaimForm } from "../../Libs/Types/UpdateClaim";

export default function UpdateClaim() {
  const [selected, setSelected] = useState<string>("");
  const [isDialogOpen, setDialogOpen] = useState<boolean>(false);
  const [files, setFiles] = useState<File[]>([]);

  const initialValues: UpdateClaimForm = {
    category: "",
    referenceNumber: "",
  };

  // Handle Dialog Close
  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  // Handle Update Claim Form Submit
  const handleUpdateClaimSubmit = (values: UpdateClaimForm) => {
    console.log(values);
    setDialogOpen(true);
  };

  return (
    <>
      <div className="px-2">
        <OutletHeading>Medical Insurance Claim Automation</OutletHeading>
        <OutletSubHeading className="mt-2">
          Update claim details
        </OutletSubHeading>

        <Formik
          initialValues={initialValues}
          onSubmit={handleUpdateClaimSubmit}
        >
          <Form className="w-full">
            <div className="grid md:grid-cols-12 gap-x-4">
              <div className="my-1 md:col-span-5">
                <Label
                  className="block text-primary text-xs my-2 font-semibold"
                  htmlFor="category"
                >
                  Select Category
                </Label>
                <Select value={selected} onValueChange={setSelected}>
                  <SelectTrigger aria-label="Fruits" className="border-primary">
                    <SelectValue placeholder="Select Category" />
                  </SelectTrigger>

                  <SelectContent>
                    <SelectItem value="Select" disabled>
                      Select Category
                    </SelectItem>
                  </SelectContent>
                  {/* 
                  <SelectContent>
                    {options.map(({ value, label }) => (
                      <SelectItem key={value} value={value}>
                        {label}
                      </SelectItem>
                    ))}

                    <SelectSeparator />
                  </SelectContent> */}
                </Select>
              </div>
              <div className="my-1 flex md:flex-col justify-center items-center md:col-span-2">
                <Label
                  className="hidden md:block invisible text-primary text-xs my-2 font-semibold"
                  htmlFor="category"
                >
                  Select
                </Label>
                <span className="text-primary font-bold text-xl ">OR</span>
              </div>
              <div className="my-1 md:col-span-5">
                <Label
                  className="block text-primary text-xs my-2 font-semibold"
                  htmlFor="referenceNumber"
                >
                  Reference Number
                </Label>
                <Field
                  as={Input}
                  className="w-full py-2 border-primary text-title outline-none rounded transition bg-white"
                  type="text"
                  id="referenceNumber"
                  name="referenceNumber"
                  // required
                  placeholder="Enter Reference Number"
                />
              </div>
              <div className="my-1 md:col-span-12">
                <Label
                  className="block text-primary text-xs my-2 font-semibold"
                  htmlFor="hcpcsCode"
                >
                  Upload Document
                </Label>
                <DocumentUpload files={files} setFiles={setFiles} />
              </div>
            </div>
            <div className="mt-5">
              <Button type="submit" className="w-full lg:w-1/4">
                Submit
              </Button>
            </div>
          </Form>
        </Formik>

        <Dialog open={isDialogOpen} onOpenChange={handleDialogClose}>
          <DialogContent className="max-w-3xl">
            <DialogIcon>
              <SuccessIcon />
            </DialogIcon>
            <DialogHeader>
              <DialogDescription className="hidden">
                Claim update request submitted successfully
              </DialogDescription>
              <DialogTitle>
                Claim update request submitted successfully
              </DialogTitle>
            </DialogHeader>
            <div className="whitespace-pre-wrap text-center text-primary text-sm">
              Lorem ipsum dolor sit amet.
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}
